import { render, staticRenderFns } from "./circles.vue?vue&type=template&id=65157644&scoped=true"
import script from "./circles.vue?vue&type=script&lang=js"
export * from "./circles.vue?vue&type=script&lang=js"
import style0 from "./circles.vue?vue&type=style&index=0&id=65157644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65157644",
  null
  
)

export default component.exports